module.exports = __webpack_public_path__ + "static/media/fabbrica-milano.8bbdd3f2.png";